<template>
  <div id="lead-performance-graph">
    <div class="ld-white-title">
      Zone - <b>{{ hvac.zone }}</b>
    </div>
    <div>
      <RuntimeBarGraph
        v-if="alert.type.includes('Runtime')"
      />
      <GaugeGraph v-else />
    </div>
    <div class="ld-white-body">
      {{ alert.description |
        formatDesc(alert.type, alert.boundaryValue) }}
    </div>
  </div>
</template>

<script>
import RuntimeBarGraph from '@shared/components/leadDetailPdf/performance/RuntimeBarGraph.vue';
import GaugeGraph from '@shared/components/leadDetailPdf/performance/GaugeGraph.vue';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'PerformanceGraph',
  components: {
    RuntimeBarGraph,
    GaugeGraph,
  },
  mixins: [leadDetailMixin],
};
</script>

<style lang="scss">

#lead-performance-graph {
  background-color: $N110;
  padding: 2rem;
  justify-items: center;
  display: grid;
  .ld-white-title {
    color: $WHITE;
    font-size: 12pt;
  }
  .ld-white-body {
    color: $WHITE;
    text-align: center;
    font-size: 12pt;
  }
}

</style>
